import PropTypes from 'prop-types';

import s from './discountTicker.module.css';

function DiscountTicker({ discount1, discount2, discount3 }) {
  return (
    <div className={s.ticker}>
      <p>
        {discount1}% <span>{`//`}</span> {discount2}% <span>{`//`}</span>{' '}
        {discount3}% <span>{`//`}</span>
      </p>
      <p aria-hidden="true">
        {discount1}% <span>{`//`}</span> {discount2}% <span>{`//`}</span>{' '}
        {discount3}% <span>{`//`}</span>
      </p>
    </div>
  );
}

export default DiscountTicker;

DiscountTicker.propTypes = {
  discount1: PropTypes.string.isRequired,
  discount2: PropTypes.string.isRequired,
  discount3: PropTypes.string.isRequired,
};
